const m = require('air-vue-model')()
m.url = 'ingredient_outlet_details'
m.name = 'ingredientOutletDetail'
m.setPagination({
    page_size: 'all'
})

module.exports = m